import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {issuesStore} from '@store/operations/issues/issues.store';

export const getIssuesDataSource = createRequestDataSource({
  store: issuesStore,
  data$: () => issuesStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getIssues',
  dataKey: 'issues',
});
